import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4671ec3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-content" }
const _hoisted_2 = { class: "flex flex-column align-items-center" }
const _hoisted_3 = { class: "centered-content p-2" }
const _hoisted_4 = { class: "flex flex-wrap md:flex-nowrap gap-4" }
const _hoisted_5 = { class: "w-5rem flex md:justify-content-end" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-label font-bold mb-3" }, "Identité du bâtiment", -1))
const _hoisted_8 = { class: "grid" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-l1 app-label-micro font-bold uppercase",
  for: "project"
}, " projet ", -1))
const _hoisted_11 = { class: "col-12 md:col-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-l1 app-label-micro font-bold uppercase",
  for: "building-alt-name"
}, " référence ", -1))
const _hoisted_13 = { class: "col-12 md:col-9" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-gray-l1 app-label-micro font-bold uppercase" }, " nom du bâtiment", -1))
const _hoisted_15 = {
  key: 0,
  class: "w-full flex justify-content-end align-items-end pt-2 pb-2"
}
const _hoisted_16 = { class: "flex flex-wrap md:flex-nowrap mt-7 mb-3 gap-4" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-5rem flex md:justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "color-tag text-white bg-green app-label-micro" }, "3/3")
], -1))
const _hoisted_18 = { class: "w-full" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-label font-bold mb-3" }, "Localisation", -1))
const _hoisted_20 = { class: "flex flex-wrap md:flex-nowrap gap-4" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "grid w-full" }
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-l1 app-label-micro font-bold uppercase",
  for: "building-name"
}, "adresse", -1))
const _hoisted_25 = { class: "col-12 md:col-8" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-l1 app-label-micro font-bold uppercase",
  for: "building-alt-name"
}, "pays", -1))
const _hoisted_27 = { class: "col-4" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-l1 app-label-micro font-bold uppercase",
  for: "building-alt-name"
}, "code postal", -1))
const _hoisted_29 = { class: "flex flex-wrap md:flex-nowrap mt-7 gap-4" }
const _hoisted_30 = { class: "w-5rem flex md:justify-content-end" }
const _hoisted_31 = { class: "w-full" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-label font-bold mb-3" }, "Syndicat de copropriété", -1))
const _hoisted_33 = { class: "grid" }
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-gray-l1 app-label-micro font-bold uppercase" }, "nom du syndic", -1))
const _hoisted_36 = { class: "col-12 md:col-6" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-gray-l1 app-label-micro font-bold uppercase" }, "mail de contact", -1))
const _hoisted_38 = { class: "col-12 md:col-6" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-gray-l1 app-label-micro font-bold uppercase" }, "téléphone", -1))
const _hoisted_40 = { class: "col-12 md:col-6" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-gray-l1 app-label-micro font-bold uppercase" }, "date de la dernière AG", -1))
const _hoisted_42 = { class: "col-12 md:col-6 flex align-items-end" }
const _hoisted_43 = { class: "field-checkbox mb-0" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "isSyndicMember" }, "Etes-vous membre du conseil syndical de copropriété ? ", -1))
const _hoisted_45 = {
  key: 1,
  class: "w-full flex justify-content-end align-items-end pt-2 pb-2"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ci-action-edit text-lg mr-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "app-label-small font-bold" }, "Photo du bâtiment")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center justify-content-center flex-column" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-gray-l1" }, "Déposez votre image ici.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_BuildingImage = _resolveComponent("BuildingImage")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BuildingImage, {
        image_url: _ctx.imageUrl,
        style: {"height":"349px","width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FileUpload, {
            mode: "basic",
            ref: "imageUpload",
            accept: "image/*",
            customUpload: true,
            onUploader: _ctx.updateBuildingPicture,
            auto: true,
            chooseLabel: _ctx.buildingInfo.image_url ? 'Modifier la photo' : 'Ajouter une photo',
            class: "secondary m"
          }, null, 8, ["onUploader", "chooseLabel"])
        ]),
        _: 1
      }, 8, ["image_url"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["color-tag text-white app-label-micro", _ctx.buildingIdentityTag.class])
            }, _toDisplayString(_ctx.buildingIdentityTag.text), 3)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_InputText, {
                  id: "project",
                  modelValue: _ctx.buildingInfo.project || 'Aucun projet',
                  class: "app-label-huge font-medium",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_InputText, {
                  id: "building-alt-name",
                  modelValue: _ctx.buildingInfo.label,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.buildingInfo.label) = $event)),
                  class: "app-label-h1 font-medium",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.nickname,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nickname) = $event)),
                  class: "app-label-h1 font-medium",
                  placeholder: "Ex: Ma maison"
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ]),
        (_ctx.identityModified)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_app_button, {
                buttonType: "main",
                buttonSize: "m",
                buttonText: "Enregistrer les modifications",
                isDisabled: _ctx.updating,
                onClick: _ctx.saveBuilding
              }, null, 8, ["isDisabled", "onClick"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              (_ctx.locationImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.locationImage,
                    class: "map-preview"
                  }, null, 8, _hoisted_21))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_component_InputText, {
                    id: "building-name",
                    class: "app-label font-medium",
                    modelValue: _ctx.buildingInfo.address?.formatted_address,
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode(_component_InputText, {
                    id: "building-name",
                    class: "app-label font-medium",
                    modelValue: _ctx.buildingInfo.address?.c,
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_InputText, {
                    id: "building-name",
                    class: "app-label font-medium",
                    modelValue: _ctx.buildingInfo.address?.p,
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", {
              class: _normalizeClass(["color-tag text-white app-label-micro", _ctx.buildingSyndicInfoTag.class])
            }, _toDisplayString(_ctx.buildingSyndicInfoTag.text), 3)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.syndicInfo.syndicName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.syndicInfo.syndicName) = $event)),
                  class: "app-label font-medium"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.syndicInfo.syndicMail,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.syndicInfo.syndicMail) = $event)),
                  class: "app-label font-medium"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.syndicInfo.syndicPhone,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.syndicInfo.syndicPhone) = $event)),
                  class: "app-label font-medium"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.syndicInfo.lastGADate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.syndicInfo.lastGADate) = $event)),
                  class: "app-label font-medium"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_Checkbox, {
                    binary: true,
                    inputId: "isSyndicMember",
                    modelValue: _ctx.syndicInfo.isSyndicMember,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.syndicInfo.isSyndicMember) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_44
                ])
              ])
            ])
          ])
        ]),
        (_ctx.syndicInfoModified)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createVNode(_component_app_button, {
                buttonType: "main",
                buttonSize: "m",
                buttonText: "Enregistrer les modifications",
                isDisabled: _ctx.updating,
                onClick: _ctx.saveCustomData
              }, null, 8, ["isDisabled", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showUpdatePicture,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showUpdatePicture) = $event)),
      modal: true,
      class: "p-fluid",
      closable: true,
      dismissableMask: true,
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '50vw' }
    }, {
      header: _withCtx(() => [
        _hoisted_46
      ]),
      default: _withCtx(() => [
        _createVNode(_component_FileUpload, {
          ref: "imageUpload",
          accept: "image/*",
          "file-limit": 1,
          customUpload: true,
          onUploader: _ctx.updateBuildingPicture,
          chooseLabel: _ctx.$t('commons.choose'),
          cancelLabel: _ctx.$t('commons.cancel'),
          uploadLabel: _ctx.$t('commons.upload')
        }, {
          empty: _withCtx(() => [
            _hoisted_47
          ]),
          _: 1
        }, 8, ["onUploader", "chooseLabel", "cancelLabel", "uploadLabel"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}